import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: "",
  },
  mutations: {
    loginData(state, v) {
      state.userInfo = v;
    },
  },
  getters: {
    userInfo_name(state) {
      var dd = state.userInfo.cName;
      return dd;
    },
  },
  actions: {
    buyVip(context,e) {
      context.commit("loginData", e);
    },
  },
  modules: {},
});
